export type { LocationsMapProps } from './LocationsMap';
export { LocationsMap } from './LocationsMap';
